// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__WiaZp","summary":"CartItem_summary__hYZaJ","price":"CartItem_price__Wf-4l","amount":"CartItem_amount__pbTWp","actions":"CartItem_actions__3yQOh"};